export const USER_ROLE_OPTIONS = [
  { value: 'SYSTEM', label: '시스템관리자' },
  { value: 'ADMIN', label: '통합관리자' },
  { value: 'MANAGER', label: '충전관리자' },
  { value: 'CHARGER', label: '충전원' },
  { value: 'DELIVERER', label: '배송원' },
  { value: 'SALES', label: '영업사원' },
  { value: 'CUSTOMER_MANAGER', label: '고객사 담당자' },
  { value: 'CUSTOMER_USER', label: '고객사 일반사용자' },
];

const ASSIGNABLE_ROLES_BY_REQUESTER_ROLE = {
  ADMIN: ['SYSTEM', 'MANAGER', 'SALES', 'CHARGER', 'DELIVERER', 'CUSTOMER_MANAGER', 'CUSTOMER_USER'],
  SYSTEM: ['MANAGER', 'SALES', 'CHARGER', 'DELIVERER', 'CUSTOMER_MANAGER', 'CUSTOMER_USER'],
  CUSTOMER_MANAGER: ['CUSTOMER_USER'],
};

export const canAssignUserRole = (requesterRole, targetRole) => {
  const assignableValues = ASSIGNABLE_ROLES_BY_REQUESTER_ROLE[requesterRole] ?? [];
  return assignableValues.includes(targetRole);
};

export const getAssignableUserRoleOptions = (requesterRole, currentRole) => {
  const assignableValues = ASSIGNABLE_ROLES_BY_REQUESTER_ROLE[requesterRole] ?? [];
  const visibleValues = currentRole
    ? Array.from(new Set([...assignableValues, currentRole]))
    : assignableValues;

  return USER_ROLE_OPTIONS.filter((option) => visibleValues.includes(option.value));
};
